<app-header></app-header>
<!-- Typ 1 - IDV -->

<div class="mt-2" *ngIf="finished">
  <mat-card class="step-card">
    <mat-card-header>
      <mat-card-title>

      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div style="text-align: center;">
        <label style="color: green;">{{"UPLOADS.FINISHED" | translate }}</label>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="mt-2" *ngIf="type == 0">
  <mat-card class="step-card">
    <mat-card-header>
      <mat-card-title>

      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div style="text-align: center;">
        <mat-error *ngIf="!notActiveAnymore">{{"UPLOADS.ERROR" | translate }}</mat-error>
        <mat-error *ngIf="notActiveAnymore">{{"UPLOADS.ERROR_NOT_ACTIVE" | translate }}</mat-error>
      </div>
    </mat-card-content>
  </mat-card>
</div>




<div class="mt-2" *ngIf="type != 0 && isActive">
  <mat-card class="step-card">
    <mat-card-header>
      <mat-card-title *ngIf="type == 1">
        {{"UPLOADS.TITLE.IDV" | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="type == 2">
        {{"UPLOADS.TITLE.DOCS" | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="type == 3">
        {{"UPLOADS.TITLE.ADDRESS" | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="type == 4">
        {{"UPLOADS.TITLE.SOF_GENERIC" | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="type == 5">
        {{"UPLOADS.TITLE.SOF_SINGLE" | translate }}
      </mat-card-title>
      <mat-card-title *ngIf="type == 6">
        {{"UPLOADS.TITLE.ADDRESS_CONFIRMATION" | translate }}
      </mat-card-title>
      <!--<mat-card-subtitle>{{"UPLOADS.PROOF_OF_IDENTITY" | translate}}</mat-card-subtitle>-->
    </mat-card-header>
    <mat-card-content>
      <div class="mt-2" *ngIf="type == 1">
        {{"UPLOADS.SUBTITLE_IDV" | translate}}
        <mat-form-field style="margin-top: 20px;">
          <mat-label>{{"UPLOADS.SELECT_DOC_TYPE" | translate}}</mat-label>
          <mat-select [formControl]="docTypeSelected" [disabled]="disabled" (selectionChange)="onDocTypeChanged()">
            <mat-option [value]="1">
              {{"UPLOADS.ID_CARD" | translate}}
            </mat-option>
            <mat-option [value]="2">
              {{"UPLOADS.DRIVER_LICENSE" | translate}}
            </mat-option>
            <mat-option [value]="3">
              {{"UPLOADS.PASSPORT" | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="mt-2" *ngIf="type == 2 || type == 4 || type == 5">
        {{"UPLOADS.SUBTITLE_DOCS" | translate}}
        <ul>
          <li>{{"UPLOADS.RETIREMENT_BENEFITS" | translate}}</li>
          <li>{{"UPLOADS.SALARY_STATEMENT" | translate}}</li>
          <li>{{"UPLOADS.BANK_STATEMENT" | translate}}</li>
          <li>{{"UPLOADS.PROOF_OF_INCOME" | translate}}</li>
        </ul>
      </div>
      <div class="mt-2" *ngIf="type == 3 || type == 6">
        {{"UPLOADS.SUBTITLE_DOCS" | translate}}
        <ul>
          <li>{{"UPLOADS.DISTRIBUTOR" | translate}}*</li>
          <li>{{"UPLOADS.BANK_STATEMENT" | translate}}*</li>
          <li>{{"UPLOADS.CERTIFICATE_REGISTRATION" | translate}}*</li>
          <li>{{"UPLOADS.PUBLIC_AUTHORITY" | translate}}*</li>
        </ul>
      </div>
      <div>
        <div class="mt-1" *ngIf="docTypeSelected.value != null || type == 2 || type == 3 || type == 4 || type == 5 || type == 6">
          <ul>
            <li>{{"UPLOADS.MAX_FILESIZE" | translate}}</li>
            <li>{{"UPLOADS.ALLOWED_FILETYPES" | translate}}</li>
          </ul>
        </div>

        <div class="mt-1" style="margin-bottom: 15px;" *ngIf="type == 3 || type == 6">
          <small>* {{"UPLOADS.NOT_OLDER_THAN_3_MONTH" | translate}}</small>
        </div>

        <!-- DOCS / IDV Passport / ADDRESS-->
        <div *ngIf="type == 2 || type == 3 || (type == 1 && docTypeSelected.value == 3) || type == 4 || type == 5 || type == 6">
          <ngx-dropzone (change)="onSelect($event)" [accept]="'image/*, application/pdf'" [multiple]="type == 2 || type == 3 || type == 6" [maxFileSize]="10485760" [disabled]="disabled || (type == 1 && docTypeSelected.value == null)">
            <ngx-dropzone-label *ngIf="type == 2 || type == 3">{{"UPLOADS.DROPTEXT" | translate }}</ngx-dropzone-label>
            <ngx-dropzone-label *ngIf="type == 1">{{"UPLOADS.DROPTEXT_SINGLE" | translate }}</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
              <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>
        </div>

        <!-- IDV driver license / ID card -->
        <div *ngIf="type == 1 && (docTypeSelected.value == 1 || docTypeSelected.value == 2)">
          <h5>{{"UPLOADS.FRONT" | translate}}</h5>
          <ngx-dropzone (change)="onFrontSelect($event)" [accept]="'image/*, application/pdf'" [maxFileSize]="10485760" [multiple]="false" [disabled]="disabled || docTypeSelected.value == null">
            <ngx-dropzone-label>{{"UPLOADS.DROPTEXT_SINGLE" | translate }}</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of filesFront" [removable]="true" (removed)="onFrontRemove(f)">
              <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>

          <h5>{{"UPLOADS.BACK" | translate}}</h5>
          <ngx-dropzone (change)="onBackSelect($event)" [accept]="'image/*, application/pdf'" [maxFileSize]="10485760" [multiple]="false" [disabled]="disabled || docTypeSelected.value == null">
            <ngx-dropzone-label>{{"UPLOADS.DROPTEXT_SINGLE" | translate }}</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of filesBack" [removable]="true" (removed)="onBackRemove(f)">
              <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>
        </div>



        <div [hidden]="!isUploading">
          <div class="spinner-2">
            <mat-spinner align="center"></mat-spinner>
          </div>
        </div>
      </div>
    </mat-card-content>

    <div class="mt-2" *ngIf="showUploadError" style="text-align: center;">
      <mat-error>{{"UPLOADS.UPLOADING_ERROR" | translate }}</mat-error>
    </div>

    <mat-card-actions align="end">
      <!-- IDV -->
      <button *ngIf="type == 1" [disabled]="
      disabled ||
      (
        (docTypeSelected.value == 1 || docTypeSelected.value == 2) && (filesFront.length <= 0 || filesBack.length <= 0) ||
        (docTypeSelected.value == 3) && (files.length <= 0 )

      )" mat-raised-button color="primary" type="button" (click)="upload()">{{"UPLOADS.UPLOADTEXT" | translate }}</button>

      <!-- DOCS / ADDRESS / SOF Single / SOF Generic -->
      <button *ngIf="type == 2 || type == 3 || type == 4 || type == 5 || type == 6" [disabled]="disabled || files == null || files.length <= 0" mat-raised-button color="primary" type="button" (click)="upload()">{{"UPLOADS.UPLOADTEXT" | translate }}</button>



    </mat-card-actions>
  </mat-card>
</div>





